import { atom } from 'jotai';
import type {
  RankingFilterMarketVerticalType,
  RankingFilterCategory,
  RankingFilterAge,
  RankingFilterPeriod,
} from 'shared/src/api';

export interface RankingFilterState {
  selectedMarketType: RankingFilterMarketVerticalType | null;
  selectedCategory: RankingFilterCategory | null;
  selectedSubCategory: RankingFilterCategory | null;
  selectedAge: RankingFilterAge | null;
  selectedPeriod: RankingFilterPeriod | null;
}

export const rankingFilterAtom = atom<RankingFilterState>({
  selectedMarketType: null,
  selectedCategory: null,
  selectedSubCategory: null,
  selectedAge: null,
  selectedPeriod: null,
});
